import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { productQueryOptions, VariantEditPage, variantsQueryOptions } from '@/features/products';

export const Route = createFileRoute(
  '/_authed/_active/org/products/$productId_/variants/$variantId',
)({
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: async ({ context, params }) => {
    const [product, variants] = await Promise.all([
      context.queryClient.query({ ...productQueryOptions(params.productId), staleTime: 'static' }),
      context.queryClient.query({ ...variantsQueryOptions(params.productId), staleTime: 'static' }),
    ]);
    const variant = variants.find((v) => v.id === params.variantId);
    return { crumb: variant ? `${product.title} · ${variant.title}` : product.title };
  },
  component: VariantEditPage,
});
